import type { Config } from "dompurify";

// Canonical cross-repo rich-text vocabulary (SCRUM-605 hardening). Explicit
// allowlist, not an ADD_TAGS/ADD_ATTR extension of DOMPurify's broad default —
// `<a>` is intentionally excluded (stripped, inner text kept).
export const SANITIZE_CONFIG: Config = {
  ALLOWED_TAGS: [
    "p",
    "strong",
    "b",
    "em",
    "i",
    "u",
    "span",
    "ul",
    "ol",
    "li",
    "br",
  ],
  ALLOWED_ATTR: ["style"],
  // DOMPurify readmits data-*/aria-* attributes on any allowed tag by
  // default, past ALLOWED_ATTR — close that gap explicitly (WU10 fold-in,
  // obs #684 gate follow-up; FE already has this parity).
  ALLOW_DATA_ATTR: false,
  ALLOW_ARIA_ATTR: false,
};
